import $$api from 'models/api';
import { useState } from 'react';

import { Frame } from 'components/StyledTemplates/StyledTemplates';
import {
    EmailInput,
    LegacyLeaves,
    ReferButton,
    ReferInputAndButtonWrapper,
    ReferTabWrapper,
} from 'components/pages/Dashboard/common/CommunityPageStyles';

import ValidateService from 'services/ValidateService';

import useResources from 'hooks/useResources';

const ReferalCard = () => {
    const { t } = useResources();
    const [email, setEmail] = useState(``);
    return (
        <ReferTabWrapper>
            <LegacyLeaves />
            <Frame extra="font-weight: bold; margin: 5px 0;">{t(`newDashboardPage.referalTabTitle`)}</Frame>
            <Frame>{t(`newDashboardPage.referalTabDescription`)}</Frame>
            <ReferInputAndButtonWrapper>
                <EmailInput
                    placeholder="Email..."
                    value={email}
                    onChange={(e) => {
                        setEmail(e?.target?.value);
                    }}
                />
                <ReferButton
                    disabled={!ValidateService.isValidEmail(email)}
                    onClick={async () => {
                        if (ValidateService.isValidEmail(email)) {
                            await $$api.participants.sendInvitationFx(email);
                            setEmail(``);
                        }
                    }}
                >
                    {t(`newDashboardPage.referalTabButtonLabel`)}
                </ReferButton>
            </ReferInputAndButtonWrapper>
        </ReferTabWrapper>
    );
};

export default ReferalCard;
